const { get } = require('@ebay/str-ui-utils/retriever');
const { trackEvent, getTracking } = require('@ebay/str-ui-utils/tracking-util');
module.exports = class {
    onCreate(input) {
        this.closedByEsc = true;
        const closeTracking = get(input, 'model.closeTracking', null);
        const closeTrackingAttr = getTracking(closeTracking);
        this.state = {
            closeTrackingAttr,
            open: input.open || false,
            dontShowMeAgain: false
        };
    }

    onMount() {
        if (this.state.open) {
            // custom code added to add focus-visible class to the checkbox input
            const consentChkElem = this.getComponent('announcement-dialog-consent-checkbox').el;
            consentChkElem.querySelector('input.checkbox__control').classList.add('focus-visible');
        }
    }

    closeDialog(trackingAttr, props = {
        dontShowMeAgain: this.state.dontShowMeAgain
    }) {
        this.state.open = false;
        // this will track for both Esc key and X click
        trackEvent(null, props, trackingAttr);
        this.emit('announcement-close', props);
    }

    handleCTA(obj) {
        // close event trigerred from CTA
        this.closedByEsc = false;
        this.closeDialog(obj.trackingAttr, {
            feature: obj.feature,
            dontShowMeAgain: this.state.dontShowMeAgain
        });
    }

    handleClose() {
        if (!this.closedByEsc) {
            // tracking and event emit is already handled for this action
            return false;
        }
        this.closeDialog(this.state.closeTrackingAttr);
    }

    handleXClick() {
        // modal is about to close through X
        this.closedByEsc = false;
        this.closeDialog(this.state.closeTrackingAttr);
    }

    handleConsent(evt) {
        this.state.dontShowMeAgain = evt.checked;
    }
};
